import { render, staticRenderFns } from "./store-Header.vue?vue&type=template&id=b81793ba&scoped=true"
import script from "./store-Header.vue?vue&type=script&lang=js"
export * from "./store-Header.vue?vue&type=script&lang=js"
import style0 from "./store-Header.vue?vue&type=style&index=0&id=b81793ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81793ba",
  null
  
)

export default component.exports